import { FlexColumn } from "../../box";
import { FloatingFieldLabel } from "../atoms";
import { BaseInput } from "../atoms/TextualInput";
import { styled } from "../../theme";
export const MainLabel = styled(FloatingFieldLabel) `
  margin: ${({ theme }) => theme.space[4]}px 0;
`;
export const Column = styled(FlexColumn) `
  padding: ${({ theme }) => theme.space[1]}px ${({ theme }) => theme.space[2]}px;
`;
export const Input = styled(BaseInput) `
  border: 1px solid ${({ theme }) => theme.color.borderGray};
  background: ${({ theme }) => theme.color.white};
  min-width: 3rem;
  max-width: 4rem;
  :focus {
    border: 1px solid ${({ theme }) => theme.color.primary};
  }
`;
export const YearInput = styled(BaseInput) `
  border: 1px solid ${({ theme }) => theme.color.borderGray};
  background: ${({ theme }) => theme.color.white};
  min-width: 5rem;
  max-width: 7rem;
  :focus {
    border: 1px solid ${({ theme }) => theme.color.primary};
  }
`;
/** We validate manually each separate input box. This styles that error message. */
export const SeparateFieldError = styled.div `
  color: ${({ theme }) => theme.color.deepOrange100};
  font-size: 1.25em;
  padding: 10px 5px;
  font-weight: ${({ theme }) => theme.fontWeight.medium};
  text-align: left;
`;
